











import { defineComponent, useAsync, useRoute, useContext, useMeta, computed } from '@nuxtjs/composition-api'

// Components
import ImageEnhancementModal from '~/components/feature/image-enhancement/ImageEnhancementModal.vue'
import { MappedProduct } from '~/types/product/productTypes'

// Common
import { stripHTMLTags } from '@/common/utils/characters'

export default defineComponent({
  name: 'ProductApplications',

  components: {
    ImageEnhancementModal,
  },

  layout: 'empty',

  setup() {
    const route = useRoute()
    const ctx = useContext()
    const productId = route.value.params.id ?? '4060'
    const applicationGroup = route.value.query.application ?? 'all'
    const type = route.value.query.type ?? 'pdp'
    const index = route.value.query.index ?? '1'
    const isPreviewServer = ctx.$config.cst.isPreview

    const productData = useAsync<MappedProduct>(async () => {
      try {
        const { data } = !isPreviewServer
          ? await ctx.$ct.products.getFullProduct(productId)
          : await ctx.$cstApi.getPreviewFullProduct(productId)

        if (!isPreviewServer) {
          return JSON.parse(data.value.cache)
        }

        return data
      } catch (e) {
        console.error(e)
      }
    })

    // Compute the product title
    const productTitle = computed(() => {
      return productData.value?.name?.['en-US' as any] ?? 'Product application'
    })

    const productBackground = computed(() => {
      return productData.value?.attributes?.productBackground ?? ''
    })

    useMeta(() => ({
      title: `Applications for ${stripHTMLTags(productTitle.value)}`,
      meta: [
        {
          hid: 'description',
          name: 'description',
          content: productBackground.value,
        },
      ],
    }))

    return {
      productData,
      applicationGroup: applicationGroup.toString(),
      productid: productId.toString(),
      index: index.toString(),
      type,
    }
  },

  head: {},
})
